import { Typography } from '@mui/material'
import * as actions from '@returnmates/client-core/src/constants/actionTypes'
import { Package } from '@returnmates/client-core/src/graphql/generated/api'
import { SnackBarStatuses } from '@returnmates/client-core/src/type'
import CopyIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/CopyIcon'
import OpenLinkIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/OpenLinkIcon'
import { WILSON_URL } from '@returnmates/ui-core/src/constants/paths'
import { memo, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import useStyles from '../styles'

interface Props {
  currentPackage: Package | null
}

const Ids = ({ currentPackage }: Props) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const copyToClipboard = useCallback(
    (id: string) => () => {
      navigator.clipboard.writeText(id || '')

      dispatch(
        actions.addSnackBar.request({
          type: SnackBarStatuses.SUCCESS,
          message: 'ID was successfully copied to the clipboard',
        }),
      )
    },
    [dispatch],
  )

  const openTrip = useCallback(() => {
    if (typeof window !== 'undefined') {
      const trackingLink = `${WILSON_URL}/trips?tripId=${currentPackage?.tripId}`
      window.open(trackingLink, '_blank')?.focus()
    }
  }, [currentPackage?.tripId])

  return (
    <div className={classes.idsContainer}>
      {currentPackage?.tripId ? (
        <div className={classes.detailsRow}>
          <div className={classes.selectWrapper}>
            <p className={classes.inputHead}>Trip Id</p>
            <div className={classes.idContainer}>
              <Typography onClick={openTrip} className={classes.id}>
                {currentPackage?.tripId}
              </Typography>
              <div className={classes.idActions}>
                <OpenLinkIcon onClick={openTrip} />
                <CopyIcon onClick={copyToClipboard(currentPackage?.tripId || '')} />
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {currentPackage?.trackingId ? (
        <div className={classes.detailsRow}>
          <div className={classes.selectWrapper}>
            <p className={classes.inputHead}>Tracking Id</p>
            <div className={classes.idContainer}>
              <Typography className={classes.id}>{currentPackage?.trackingId}</Typography>
              <div className={classes.idActions}>
                <CopyIcon onClick={copyToClipboard(currentPackage?.trackingId || '')} />
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {currentPackage?.locationId ? (
        <div className={classes.detailsRow}>
          <div className={classes.selectWrapper}>
            <p className={classes.inputHead}>Location Id</p>
            <div className={classes.idContainer}>
              <Typography className={classes.id}>{currentPackage?.locationId}</Typography>
              <div className={classes.idActions}>
                <CopyIcon onClick={copyToClipboard(currentPackage.locationId || '')} />
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {currentPackage?.polybagId ? (
        <div className={classes.detailsRow}>
          <div className={classes.selectWrapper}>
            <p className={classes.inputHead}>Polybag Id</p>
            <div className={classes.idContainer}>
              <Typography className={classes.id}>{currentPackage?.polybagId}</Typography>
              <div className={classes.idActions}>
                <CopyIcon onClick={copyToClipboard(currentPackage?.polybagId || '')} />
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default memo(Ids)
